webpackJsonp([56],Array(69).concat([
/* 69 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 70 */,
/* 71 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_format__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_date_fns_format__);



function formatDate(date) {
	var formatter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD-MM-YYYY';

	var newDate = __WEBPACK_IMPORTED_MODULE_1_date_fns_format___default()(new Date(date), formatter);
	return newDate;
}

function generateBlob(data) {
	var contentType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'application/pdf';

	return new Blob([data], { type: contentType });
}

function getLocalData(key) {
	return JSON.parse(localStorage.getItem("acl" + '::' + key));
}

function getLocalStorage() {
	return JSON.parse(localStorage.getItem('' + "acl"));
}

function getLocalToken() {
	return localStorage.getItem("acl" + '::token');
}

function removeLocalData(key) {
	return localStorage.removeItem("acl" + '::' + key);
}

function setLocalData(key, data) {
	return localStorage.setItem("acl" + '::' + key, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
}

function showDownloadDialog(blob, name, extension) {
	var currentDate = __WEBPACK_IMPORTED_MODULE_1_date_fns_format___default()(new Date(), 'YYYY-MM-DD');
	var link = document.createElement('a');
	link.download = name + '_' + currentDate + '.' + extension;
	link.href = window.URL.createObjectURL(blob);
	link.click();
}

/* eslint-disable */
function debounce(func) {
	var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 800;
	var immediate = arguments[2];

	var timeout;
	return function () {
		var context = this,
		    args = arguments;
		var later = function later() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

var methods = {
	debounce: debounce,
	formatDate: formatDate,
	generateBlob: generateBlob,
	getLocalData: getLocalData,
	getLocalStorage: getLocalStorage,
	getLocalToken: getLocalToken,
	removeLocalData: removeLocalData,
	setLocalData: setLocalData,
	showDownloadDialog: showDownloadDialog
};

/* harmony default export */ __webpack_exports__["a"] = (methods);

/***/ }),
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

function snackbar() {
	return this.$store.getters.snackbar;
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app',
	computed: {
		snackbar: snackbar
	}
});

/***/ }),
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 119 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_helper__ = __webpack_require__(91);







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
	state: {
		appConfig: {
			isLoading: false,
			snackbar: {
				text: '',
				isVisible: false,
				color: 'primary',
				timeout: 5000
			}
		},
		user: {
			email: '',
			logo: '',
			profileImage: '',
			username: ''
		},
		token: __WEBPACK_IMPORTED_MODULE_5__shared_helper__["a" /* default */].getLocalToken()
	},
	actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */],
	getters: __WEBPACK_IMPORTED_MODULE_3__getters__["a" /* default */],
	mutations: __WEBPACK_IMPORTED_MODULE_4__mutations__["a" /* default */]
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function closeDrawer() {
	this.$emit('close-modal', false);
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'action-sidebar',
	methods: {
		closeDrawer: closeDrawer
	},
	model: {
		prop: 'value',
		event: 'close-modal'
	},
	props: {
		title: {
			type: String,
			required: true
		},
		value: {
			type: Boolean,
			required: true
		},
		width: {
			type: Number,
			default: 600
		},
		codeAction: {
			type: String,
			required: false
		},
		imgSrc: {
			type: String
		},
		headerColor: {
			type: String,
			default: 'white'
		},
		isLoading: {
			default: false,
			type: Boolean
		}
	}
});

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'layout-login'
});

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_action_sidebar__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_app_header__ = __webpack_require__(489);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function closeNotificationsModal() {
	this.action.active = false;
	this.action.open = false;
}

function getRoutes(routes) {
	this.routes = routes;
}

function notifications() {
	var allNotifications = [];
	if (this.productsNotifications.length > 0) {
		this.productsNotifications.forEach(function (productNot) {
			allNotifications.push(productNot);
		});
	}
	if (this.salesNotifications.length > 0) {
		this.salesNotifications.forEach(function (saleNot) {
			allNotifications.push(saleNot);
		});
	}
	return allNotifications;
}

function openNotificationsModal() {
	this.action.active = true;
	this.action.open = true;
}

function quantityNotifications() {
	return 0;
}

function currentYear() {
	return new Date().getFullYear();
}

function toggleSidebar() {
	this.isVisible = !this.isVisible;
}

function data() {
	return {
		action: {
			active: false,
			code: 'NOT',
			open: false,
			title: 'Notificaciones',
			width: 468
		},
		isVisible: true,
		loading: false,
		routes: []
	};
}

function showIndeterminate() {
	return this.$store.getters.indeterminate;
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'layout-admin',
	components: {
		actionSidebar: __WEBPACK_IMPORTED_MODULE_0__components_shared_action_sidebar__["default"],
		appHeader: __WEBPACK_IMPORTED_MODULE_1__components_shared_app_header__["a" /* default */]
	},
	computed: {
		currentYear: currentYear,
		showIndeterminate: showIndeterminate,
		notifications: notifications,
		quantityNotifications: quantityNotifications
	},
	data: data,
	methods: {
		closeNotificationsModal: closeNotificationsModal,
		getRoutes: getRoutes,
		openNotificationsModal: openNotificationsModal,
		toggleSidebar: toggleSidebar
	}
});

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);



var logout = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.next = 2;
						return this.$http.post('logout', {
							headers: {
								authorization: 'Bearer ' + this.token
							}
						});

					case 2:
						window.localStorage.clear();
						this.$store.dispatch('clearUser');
						this.$router.push({ name: 'login' });

					case 5:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function logout() {
		return _ref.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


function openNotifications() {
	this.$emit('open-notifications-event');
}

function profileImage() {
	return this.$store.getters.profileImage;
}

function companyLogo() {
	return this.getImageUrl(this.$store.getters.companyLogo);
}

function userName() {
	return this.$store.getters.userName;
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app-header',
	computed: {
		companyLogo: companyLogo,
		profileImage: profileImage,
		userName: userName
	},
	methods: {
		logout: logout,
		openNotifications: openNotifications
	},
	props: {
		quantityNotifications: {
			default: 0,
			type: Number
		}
	}
});

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'general-filter'
});

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_nan__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__table_column_item__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_helper__ = __webpack_require__(91);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var ADD_REQUEST_EVENT = 'on-add-event';
var LOCAL_SEARCH_EVENT = 'on-local-search';
var SEARCH_EVENT = 'on-search-event';
var ON_DRAG_EVENT = 'on-drag-event';
var ON_DRAG_ENTER = 'on-drag-enter';
var ON_DRAG_LEAVE = 'on-drag-leave';
var ON_DROP_EVENT = 'on-drop-event';
var ON_PAGE_EVENT = 'on-page';
var ROW_IS_SELECTED = 'row-is-selected';
var SELECTED_ALL_EVENT = 'on-selected-all';
var TABLE_OPTION_EVENT = 'table-option-event';

var components = {
	TableColumnItem: __WEBPACK_IMPORTED_MODULE_5__table_column_item__["a" /* default */]
};

function addOption() {
	this.$emit(ADD_REQUEST_EVENT);
}

function pagination(pageNumber, totalRecords) {
	var current = pageNumber;
	var last = totalRecords;
	var delta = 2;
	var left = current - delta;
	var right = current + delta + 1;
	var range = [];
	var rangeWithDots = [];
	var l = null;

	for (var i = 1; i <= last; i += 1) {
		/* eslint-disable no-mixed-operators */
		if (i === 1 || i === last || i >= left && i < right) {
			range.push(i);
		}
	}

	/* eslint-disable no-restricted-syntax */
	var _iteratorNormalCompletion = true;
	var _didIteratorError = false;
	var _iteratorError = undefined;

	try {
		for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(range), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
			var _i = _step.value;

			if (l) {
				if (_i - l === 2) {
					rangeWithDots.push(l + 1);
				} else if (_i - l !== 1) {
					rangeWithDots.push('...');
				}
			}
			rangeWithDots.push(_i);
			l = _i;
		}
	} catch (err) {
		_didIteratorError = true;
		_iteratorError = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion && _iterator.return) {
				_iterator.return();
			}
		} finally {
			if (_didIteratorError) {
				throw _iteratorError;
			}
		}
	}

	return rangeWithDots;
}

function data() {
	return {
		direction: 'right',
		search: '',
		showMenu: false
	};
}

function mounted() {
	window.addEventListener('resize', this.optionsDirection);
	document.addEventListener('click', this.closeActionMenus);
	this.optionsDirection();
	var columnsInLocalStorage = __WEBPACK_IMPORTED_MODULE_6__shared_helper__["a" /* default */].getLocalData(this.$attrs.name + '::columns');
	if (columnsInLocalStorage) {
		this.columns.forEach(function (col) {
			var newCol = col;
			var colToChange = columnsInLocalStorage.find(function (c) {
				return c.id === newCol.id;
			});
			if (colToChange) {
				newCol.visible = colToChange.visible;
				newCol.checked = colToChange.checked;
			}
		});
	}
	if (this.localStorage) {
		var searchFromLocalStorage = __WEBPACK_IMPORTED_MODULE_6__shared_helper__["a" /* default */].getLocalData(this.$attrs.name + '::search');
		if (searchFromLocalStorage) {
			this.search = searchFromLocalStorage;
			this.$emit(SEARCH_EVENT, searchFromLocalStorage);
		}
	}
	this.$nextTick(this.decorateActionMenus);
}

function updated() {
	this.$nextTick(this.decorateActionMenus);
}

function beforeDestroy() {
	window.removeEventListener('resize', this.optionsDirection);
	document.removeEventListener('click', this.closeActionMenus);
}

function closeActionMenus(event) {
	if (event && event.target.closest('.table-action-menu')) {
		return;
	}
	this.$el.querySelectorAll('.table-action-menu.open').forEach(function (menu) {
		return menu.classList.remove('open');
	});
}

function actionColor(action) {
	var label = (action.getAttribute('aria-label') || '').toLowerCase();
	var icon = action.querySelector('.material-icons');
	var iconName = icon ? icon.textContent.trim() : '';
	if (/editar/.test(label) || /edit|create/.test(iconName)) return '#3B82C4';
	if (/eliminar|borrar/.test(label) || /delete|highlight_off/.test(iconName)) return '#ef5350';
	if (/proceso|configurar/.test(label) || /build|settings/.test(iconName)) return '#e39122';
	if (/recurso/.test(label) || /cached|sync/.test(iconName)) return '#1A4338';
	if (/rol|permiso/.test(label) || /developer_board|lock/.test(iconName)) return '#7657d5';
	if (/detalle|ver/.test(label) || /visibility/.test(iconName)) return '#35a85b';
	if (/compañ|crear|nueva|agregar/.test(label) || /add/.test(iconName)) return '#1A4338';
	if (/usuario|dispositivo/.test(label) || /people|devices/.test(iconName)) return '#4f6fd3';
	if (/integr|compartir/.test(label) || /share/.test(iconName)) return '#1a9b7a';
	var classes = action.className;
	if (/red--text|error--text/.test(classes)) return '#ef5350';
	if (/green--text|success--text/.test(classes)) return '#35a85b';
	if (/orange--text|warning--text/.test(classes)) return '#f59e0b';
	if (/primary--text|primary--text|info--text|infor--text/.test(classes)) return '#1A4338';
	return '#607d8b';
}

function decorateActionMenus() {
	var _this = this;

	var actionCells = this.$el.querySelectorAll('tbody td:last-child');
	actionCells.forEach(function (cell) {
		var actions = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from___default()(cell.querySelectorAll('.action-icon-button'));
		if (actions.length < 2 || cell.querySelector('.table-action-menu')) {
			return;
		}
		cell.classList.add('table-action-cell');
		actions[0].classList.add('table-primary-action');
		actions.slice(1).forEach(function (action) {
			return action.classList.add('table-secondary-action');
		});
		var menu = document.createElement('div');
		menu.className = 'table-action-menu';
		var trigger = document.createElement('button');
		trigger.type = 'button';
		trigger.className = 'table-action-trigger';
		trigger.setAttribute('aria-label', 'Más acciones');
		trigger.setAttribute('title', 'Más acciones');
		trigger.innerHTML = '<i class="material-icons">more_horiz</i>';
		var popover = document.createElement('div');
		popover.className = 'table-action-popover';
		actions.slice(1).forEach(function (action) {
			var item = document.createElement('button');
			item.type = 'button';
			item.className = 'table-action-item';
			item.style.setProperty('--action-color', actionColor(action));
			var icon = action.querySelector('.material-icons');
			item.innerHTML = '<i class="material-icons">' + (icon ? icon.textContent : 'arrow_forward') + '</i><span>' + (action.getAttribute('aria-label') || 'Acción') + '</span>';
			item.addEventListener('click', function (event) {
				event.stopPropagation();
				action.click();
				menu.classList.remove('open');
			});
			popover.appendChild(item);
		});
		trigger.addEventListener('click', function (event) {
			event.stopPropagation();
			var wasOpen = menu.classList.contains('open');
			_this.closeActionMenus();
			var bounds = trigger.getBoundingClientRect();
			popover.style.right = window.innerWidth - bounds.right + 'px';
			popover.style.top = bounds.bottom + 5 + 'px';
			menu.classList.toggle('open', !wasOpen);
		});
		menu.appendChild(trigger);
		menu.appendChild(popover);
		cell.appendChild(menu);
	});
}

function toggleColumns() {
	var _this2 = this;

	this.selectedColumns = this.columns.filter(function (c) {
		return !c.checked;
	});
	this.columns.forEach(function (col) {
		var newCol = col;
		var colToChange = _this2.selectedColumns.find(function (c) {
			return c.id === newCol.id;
		});
		newCol.visible = typeof colToChange === 'undefined';
	});
	__WEBPACK_IMPORTED_MODULE_6__shared_helper__["a" /* default */].setLocalData(this.$attrs.name + '::columns', this.selectedColumns);
	this.showMenu = false;
}

function selectedAll(_ref) {
	var target = _ref.target;

	this.$emit(SELECTED_ALL_EVENT, target.checked);
}

function rowIsSelected(row) {
	var newRow = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, row);
	newRow[this.selectedValue] = !newRow[this.selectedValue];
	this.$emit(ROW_IS_SELECTED, newRow);
}

function searchRows($event) {
	var keyCode = $event.keyCode;
	if (keyCode === 27) {
		this.search = '';
	}
	if (this.localSearch) {
		var dataToLocalSearch = this.search.toLowerCase();
		__WEBPACK_IMPORTED_MODULE_6__shared_helper__["a" /* default */].setLocalData(this.$attrs.name + '::search', dataToLocalSearch);
		this.$emit(LOCAL_SEARCH_EVENT, dataToLocalSearch);
	} else {
		__WEBPACK_IMPORTED_MODULE_6__shared_helper__["a" /* default */].setLocalData(this.$attrs.name + '::search', this.search);
		this.$emit(SEARCH_EVENT, this.search);
	}
}

function onDragEnter(row) {
	this.$emit(ON_DRAG_ENTER, row);
}

function onDragLeave(row) {
	this.$emit(ON_DRAG_LEAVE, row);
}

function onDrop(row) {
	this.$emit(ON_DROP_EVENT, row);
}

function onDrag(row) {
	this.$emit(ON_DRAG_EVENT, row);
}

function changePage(page) {
	if (page !== '...') {
		if (page !== this.currentPage) {
			this.$emit(ON_PAGE_EVENT, page);
		}
	}
}

function cleanSearch(val) {
	if (val) {
		this.search = '';
	}
}

function syncSearchValue(value) {
	this.search = value || '';
}

function selectPage(page) {
	var newPage = page > this.lastPage ? this.lastPage : page;
	newPage = newPage <= 0 ? 1 : newPage;
	changePage.call(this, Number(newPage));
}

function selectLastPage() {
	changePage.call(this, this.lastPage);
}

function tableOption() {
	var action = {
		active: true,
		code: 'filter-by',
		color: '#fafafa',
		open: true,
		title: 'FILTRAR POR',
		width: 229
	};
	this.$emit(TABLE_OPTION_EVENT, action);
}

function optionsDirection() {
	if (window.innerWidth < 768) {
		this.direction = 'left';
	} else {
		this.direction = 'right';
	}
}

function totalVisibleColumns() {
	var selectionColumn = this.selectable ? 1 : 0;
	return this.columns.filter(function (c) {
		return c.visible;
	}).length + selectionColumn;
}

function appearanceClass() {
	return this.appearance ? 'table-' + this.appearance : '';
}

function recordTotal() {
	var total = Number(this.rows.totalRecords);
	return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_nan___default()(total) ? this.rows.length : total;
}

function formattedRecordTotal() {
	return this.recordTotal.toLocaleString('es-EC');
}

function pages() {
	return pagination(this.currentPage, this.lastPage);
}

function hasColumnWidths() {
	return this.columnWidths && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.columnWidths).length > 0;
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app-table',
	components: components,
	computed: {
		appearanceClass: appearanceClass,
		formattedRecordTotal: formattedRecordTotal,
		hasColumnWidths: hasColumnWidths,
		pages: pages,
		recordTotal: recordTotal,
		totalVisibleColumns: totalVisibleColumns
	},
	data: data,
	methods: {
		addOption: addOption,
		actionColor: actionColor,
		closeActionMenus: closeActionMenus,
		decorateActionMenus: decorateActionMenus,
		onDrag: onDrag,
		onDragEnter: onDragEnter,
		onDragLeave: onDragLeave,
		onDrop: onDrop,
		optionsDirection: optionsDirection,
		rowIsSelected: rowIsSelected,
		searchRows: searchRows,
		selectedAll: selectedAll,
		selectPage: selectPage,
		selectLastPage: selectLastPage,
		tableOption: tableOption,
		toggleColumns: toggleColumns
	},
	mounted: mounted,
	updated: updated,
	beforeDestroy: beforeDestroy,
	props: {
		appearance: {
			default: 'modern',
			type: String
		},
		addButton: {
			default: false,
			type: Boolean
		},
		checkAll: {
			type: Boolean,
			default: false
		},
		columns: {
			type: Array,
			required: true
		},
		columnWidths: {
			type: Object,
			default: function _default() {
				return {};
			}
		},
		currentPage: {
			type: Number,
			default: 1
		},
		dispatchDetail: {
			default: false,
			type: Boolean
		},
		filterColumns: {
			default: true,
			type: Boolean
		},
		includeFilter: {
			type: Boolean,
			default: false
		},
		inputSearch: {
			default: true,
			type: Boolean
		},
		localSearch: {
			type: Boolean,
			default: false
		},
		localStorage: {
			type: Boolean,
			default: false
		},
		rows: {
			type: Array,
			required: true
		},
		searchValue: {
			type: String,
			default: ''
		},
		selectable: {
			type: Boolean,
			default: false
		},
		lastPage: {
			type: Number,
			default: 0
		},
		keyValue: {
			type: String,
			default: 'id'
		},
		mainList: {
			type: Boolean,
			default: true
		},
		disabledTable: {
			type: Boolean,
			default: false
		},
		cleanSearch: {
			default: false,
			type: Boolean
		},
		compact: {
			default: true,
			type: Boolean
		},
		contained: {
			default: true,
			type: Boolean
		},
		selectedValue: {
			default: 'isSelected',
			type: String
		},
		stickyHeader: {
			default: true,
			type: Boolean
		}
	},
	watch: {
		cleanSearch: cleanSearch,
		searchValue: {
			handler: syncSearchValue,
			immediate: true
		}
	}
});

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var SORTABLE_COLUMN_EVENT = 'on-column-sortable';

function onColumnSortable(column) {
	this.$emit(SORTABLE_COLUMN_EVENT, column);
}

/* harmony default export */ __webpack_exports__["a"] = ({
	methods: {
		onColumnSortable: onColumnSortable
	},
	name: 'table-column-item',
	props: {
		column: {
			type: Object,
			required: true
		},
		onCloumnSortable: {
			type: Function
		}
	}
});

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function data() {
	return {
		breadcrumbs: []
	};
}

function cleanFilter() {
	this.$emit('clean-product-filter');
}

function columnsToExport() {
	var columnsSelected = this.columns.filter(function (column) {
		return column.visible && !column.flagVisible;
	});
	/* eslint-disable arrow-parens */
	var newColumns = columnsSelected.map(function (col) {
		var newCol = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, col);
		delete newCol.id;
		delete newCol.visible;
		delete newCol.checked;
		return newCol;
	});
	return newColumns;
}
function dataToExport() {
	var tableDataToExport = [];
	var columnsSelected = this.columns.filter(function (column) {
		return column.visible && !column.flagVisible;
	});
	var columnsValues = columnsSelected.map(function (colVal) {
		var newColVal = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, colVal);
		return newColVal.value;
	});
	if (this.rows.length > 0) {
		tableDataToExport = this.rows.map(function (dataExport) {
			var newData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, dataExport);
			var keysData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(dataExport);
			keysData.forEach(function (keyData) {
				if (columnsValues.every(function (keyCol) {
					return keyCol !== keyData;
				})) {
					delete newData[keyData];
				}
			});
			return newData;
		});
	}
	return tableDataToExport;
}

function visibleBreadcrumbs() {
	var meaningfulItems = this.breadcrumbs.filter(function (item, index) {
		return index === 0 || !/^\d+$/.test(String(item.title || '').trim());
	});
	if (meaningfulItems.length <= 2) return meaningfulItems;
	return [meaningfulItems[0], meaningfulItems[meaningfulItems.length - 1]];
}

function downloadDispatch() {
	this.$emit('download-dispatch');
}

function downloadDocument() {
	this.exportTable(this.columnsToExport, this.dataToExport, this.name);
}

function openLink(_ref) {
	var name = _ref.name;

	this.goTo(name, { params: this.$route.params });
}

function goBack() {
	var _$route$query = this.$route.query,
	    returnTo = _$route$query.returnTo,
	    returnParams = _$route$query.returnParams;

	if (returnTo && this.$route.name === 'page-user') {
		var params = {};
		try {
			params = returnParams ? JSON.parse(returnParams) : {};
		} catch (error) {
			params = {};
		}
		this.goTo(returnTo, { params: params, query: {} });
		return;
	}
	var previousRoute = this.breadcrumbs.slice(0, -1).reverse().find(function (item) {
		return item.name;
	});
	if (previousRoute) {
		this.openLink(previousRoute);
	}
}

function print() {
	window.print();
}

function routeHandler(newVal) {
	var _this = this;

	this.breadcrumbs = newVal.matched.reduce(function (acum, route) {
		var routesToAcum = [];
		var keys = route.regex.keys;
		if (keys.length > 0) {
			keys.forEach(function (key) {
				var name = _this.$route.params[key.name];
				if (name) {
					var indexAcum = acum.findIndex(function (ac) {
						return ac.title === name;
					});
					if (indexAcum === -1) {
						routesToAcum.push({ title: name });
					}
				}
			});
		}
		routesToAcum.push({ name: route.name, title: route.meta.title });
		return acum.concat(routesToAcum);
	}, []);
}

function openHome() {
	this.goTo('page-project');
}

function openConfiguration() {
	this.goTo('page-config-dealers');
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'header-page',
	computed: {
		columnsToExport: columnsToExport,
		dataToExport: dataToExport,
		visibleBreadcrumbs: visibleBreadcrumbs
	},
	data: data,
	methods: {
		cleanFilter: cleanFilter,
		downloadDispatch: downloadDispatch,
		downloadDocument: downloadDocument,
		goBack: goBack,
		openLink: openLink,
		openHome: openHome,
		openConfiguration: openConfiguration,
		print: print
	},
	props: {
		columns: {
			type: Array
		},
		exportToPdf: {
			default: false,
			type: Boolean
		},
		name: {
			type: String
		},
		rows: {
			type: Array
		},
		showClean: {
			default: true,
			type: Boolean
		},
		showExcel: {
			default: true,
			type: Boolean
		},
		title: {
			type: String,
			required: true
		},
		toShow: {
			default: false,
			type: Boolean
		},
		quotation: {
			default: false,
			type: Boolean
		},
		sale: {
			default: false,
			type: Boolean
		}
	},
	watch: {
		$route: {
			handler: routeHandler,
			immediate: true
		}
	}
});

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'form-section',
	props: {
		badge: {
			default: '',
			type: String
		},
		description: {
			default: '',
			type: String
		},
		eyebrow: {
			default: '',
			type: String
		},
		icon: {
			default: 'tune',
			type: String
		},
		tight: {
			default: false,
			type: Boolean
		},
		title: {
			required: true,
			type: String
		},
		tone: {
			default: 'brand',
			type: String
		}
	}
});

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'form-sidebar'
});

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


function cancelModal() {
	this.$emit('cancel-button-clicked');
}

function setInfo() {
	this.$emit('accept-button-clicked');
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'modal-sidebar-button',
	methods: {
		cancelModal: cancelModal,
		setInfo: setInfo
	},
	props: {
		isLoading: {
			default: true,
			type: Boolean
		},
		hidden: {
			type: Boolean,
			default: false
		},
		hiddenSaveBtn: {
			type: Boolean,
			default: false
		},
		helperText: {
			default: '',
			type: String
		},
		onRunService: {
			default: false,
			type: Boolean
		},
		successColor: {
			default: 'primary',
			type: String
		},
		successImg: {
			default: 'icon-apply.svg',
			type: String
		},
		successText: {
			default: 'Guardar',
			type: String
		}
	}
});

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_action_sidebar_vue__ = __webpack_require__(153);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b732ae24_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_action_sidebar_vue__ = __webpack_require__(452);
function injectStyle (ssrContext) {
  __webpack_require__(450)
  __webpack_require__(451)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b732ae24"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_action_sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b732ae24_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_action_sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_analytics__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_normalize_css__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_normalize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_normalize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vuetify__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__http_index__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__axios__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__router__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_global__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__filters_global__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__global_components__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__store__ = __webpack_require__(146);



var created = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						this.$http.interceptors.request.use(this.httpRequestInterceptor);
						this.$http.interceptors.response.use(this.httpResponseSuccessInterceptor, this.httpResponseInterceptor);
						this.$httpMock.interceptors.request.use(this.httpRequestInterceptor);
						this.$httpMock.interceptors.response.use(this.httpResponseSuccessInterceptor, this.httpResponseInterceptor);

					case 4:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function created() {
		return _ref.apply(this, arguments);
	};
}();

/* eslint-disable no-new */
















__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuelidate___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_analytics___default.a, {
	id: 'UA-XXXXXXX-1',
	autoTracking: {
		screenview: true
	},
	disableScriptLoader: true,
	sendHitTask: window.location.hostname === 'acl.japisale.com'
});

var router = Object(__WEBPACK_IMPORTED_MODULE_10__router__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2_vue__["default"]);
Object(__WEBPACK_IMPORTED_MODULE_12__filters_global__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2_vue__["default"]);
Object(__WEBPACK_IMPORTED_MODULE_7__vuetify__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2_vue__["default"]);
Object(__WEBPACK_IMPORTED_MODULE_9__axios__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2_vue__["default"]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$imageUrl = '//s3.amazonaws.com/apprunn-acl';
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$projectId = 0;
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_11__mixins_global__["a" /* default */]);

new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]({
	created: created,
	el: '#app',
	methods: {
		httpRequestInterceptor: __WEBPACK_IMPORTED_MODULE_8__http_index__["a" /* httpRequestInterceptor */],
		httpResponseInterceptor: __WEBPACK_IMPORTED_MODULE_8__http_index__["b" /* httpResponseInterceptor */],
		httpResponseSuccessInterceptor: __WEBPACK_IMPORTED_MODULE_8__http_index__["c" /* httpResponseSuccessInterceptor */]
	},
	router: router,
	render: function render(h) {
		return h(__WEBPACK_IMPORTED_MODULE_6__App__["a" /* default */]);
	},
	store: __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */]
});

/***/ }),
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 221 */,
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(111);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08f6b612_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(224);
function injectStyle (ssrContext) {
  __webpack_require__(223)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08f6b612_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 223 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('router-view'),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":_vm.snackbar.timeout,"color":_vm.snackbar.color,"top":true,"right":true},model:{value:(_vm.snackbar.isVisible),callback:function ($$v) {_vm.$set(_vm.snackbar, "isVisible", $$v)},expression:"snackbar.isVisible"}},[_vm._v("\n\t\t"+_vm._s(_vm.snackbar.text)+"\n\t\t"),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.snackbar.isVisible = false}}},[_vm._v("Cerrar")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetify_src_stylus_app_styl__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetify_src_stylus_app_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuetify_src_stylus_app_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify_es5_components_Vuetify__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify_es5_components_Vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify_es5_components_Vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify_es5_components_VAlert__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify_es5_components_VAlert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetify_es5_components_VAlert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify_es5_components_VApp__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify_es5_components_VApp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify_es5_components_VApp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_es5_components_VBreadcrumbs__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_es5_components_VBreadcrumbs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuetify_es5_components_VBreadcrumbs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify_es5_components_VBtn__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify_es5_components_VBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuetify_es5_components_VBtn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetify_es5_components_VBtnToggle__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetify_es5_components_VBtnToggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuetify_es5_components_VBtnToggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetify_es5_components_VCard__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetify_es5_components_VCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuetify_es5_components_VCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuetify_es5_components_VCheckbox__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuetify_es5_components_VCheckbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuetify_es5_components_VCheckbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuetify_es5_components_VChip__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuetify_es5_components_VChip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vuetify_es5_components_VChip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuetify_es5_components_VCombobox__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuetify_es5_components_VCombobox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vuetify_es5_components_VCombobox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuetify_es5_components_VDataIterator__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuetify_es5_components_VDataIterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vuetify_es5_components_VDataIterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuetify_es5_components_VDatePicker__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuetify_es5_components_VDatePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vuetify_es5_components_VDatePicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuetify_es5_components_VDialog__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuetify_es5_components_VDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vuetify_es5_components_VDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vuetify_es5_components_VDivider__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vuetify_es5_components_VDivider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vuetify_es5_components_VDivider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vuetify_es5_components_VForm__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vuetify_es5_components_VForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vuetify_es5_components_VForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vuetify_es5_components_VGrid__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vuetify_es5_components_VGrid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vuetify_es5_components_VGrid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vuetify_es5_components_VIcon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vuetify_es5_components_VIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vuetify_es5_components_VIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vuetify_es5_components_VList__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vuetify_es5_components_VList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vuetify_es5_components_VList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vuetify_es5_components_VMenu__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vuetify_es5_components_VMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vuetify_es5_components_VMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vuetify_es5_components_VNavigationDrawer__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vuetify_es5_components_VNavigationDrawer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vuetify_es5_components_VNavigationDrawer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vuetify_es5_components_VRadioGroup__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vuetify_es5_components_VRadioGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_vuetify_es5_components_VRadioGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vuetify_es5_components_VSelect__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vuetify_es5_components_VSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_vuetify_es5_components_VSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vuetify_es5_components_VSlider__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vuetify_es5_components_VSlider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_vuetify_es5_components_VSlider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vuetify_es5_components_VSnackbar__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vuetify_es5_components_VSnackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_vuetify_es5_components_VSnackbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vuetify_es5_components_VSubheader__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vuetify_es5_components_VSubheader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_vuetify_es5_components_VSubheader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vuetify_es5_components_VTextField__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vuetify_es5_components_VTextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_vuetify_es5_components_VTextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_vuetify_es5_components_VTextarea__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_vuetify_es5_components_VTextarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_vuetify_es5_components_VTextarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vuetify_es5_components_VTimePicker__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vuetify_es5_components_VTimePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_vuetify_es5_components_VTimePicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vuetify_es5_components_VToolbar__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vuetify_es5_components_VToolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_vuetify_es5_components_VToolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_vuetify_es5_components_VTooltip__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_vuetify_es5_components_VTooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_vuetify_es5_components_VTooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_vuetify_es5_components_transitions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_vuetify_es5_components_transitions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_vuetify_es5_components_transitions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_vuetify_es5_components_VExpansionPanel__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_vuetify_es5_components_VExpansionPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_vuetify_es5_components_VExpansionPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_vuetify_es5_components_VDataTable__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_vuetify_es5_components_VDataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_vuetify_es5_components_VDataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_vuetify_es5_components_VProgressLinear__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_vuetify_es5_components_VProgressLinear___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_vuetify_es5_components_VProgressLinear__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_vuetify_es5_components_VTabs__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_vuetify_es5_components_VTabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_vuetify_es5_components_VTabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_vuetify_es5_components_VStepper__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_vuetify_es5_components_VStepper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_vuetify_es5_components_VStepper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_vuetify_es5_components_VSwitch__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_vuetify_es5_components_VSwitch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_vuetify_es5_components_VSwitch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_vuetify_es5_components_VAutocomplete__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_vuetify_es5_components_VAutocomplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38_vuetify_es5_components_VAutocomplete__);









































/* harmony default export */ __webpack_exports__["a"] = (function (Vue) {
	Vue.use(__WEBPACK_IMPORTED_MODULE_1_vuetify_es5_components_Vuetify___default.a, {
		components: {
			VAlert: __WEBPACK_IMPORTED_MODULE_2_vuetify_es5_components_VAlert___default.a,
			VApp: __WEBPACK_IMPORTED_MODULE_3_vuetify_es5_components_VApp___default.a,
			VBreadcrumbs: __WEBPACK_IMPORTED_MODULE_4_vuetify_es5_components_VBreadcrumbs___default.a,
			VBtn: __WEBPACK_IMPORTED_MODULE_5_vuetify_es5_components_VBtn___default.a,
			VBtnToggle: __WEBPACK_IMPORTED_MODULE_6_vuetify_es5_components_VBtnToggle___default.a,
			VCheckbox: __WEBPACK_IMPORTED_MODULE_8_vuetify_es5_components_VCheckbox___default.a,
			VChip: __WEBPACK_IMPORTED_MODULE_9_vuetify_es5_components_VChip___default.a,
			VCard: __WEBPACK_IMPORTED_MODULE_7_vuetify_es5_components_VCard___default.a,
			VCombobox: __WEBPACK_IMPORTED_MODULE_10_vuetify_es5_components_VCombobox___default.a,
			VDataIterator: __WEBPACK_IMPORTED_MODULE_11_vuetify_es5_components_VDataIterator___default.a,
			VDatePicker: __WEBPACK_IMPORTED_MODULE_12_vuetify_es5_components_VDatePicker___default.a,
			VDialog: __WEBPACK_IMPORTED_MODULE_13_vuetify_es5_components_VDialog___default.a,
			VDivider: __WEBPACK_IMPORTED_MODULE_14_vuetify_es5_components_VDivider___default.a,
			VForm: __WEBPACK_IMPORTED_MODULE_15_vuetify_es5_components_VForm___default.a,
			VGrid: __WEBPACK_IMPORTED_MODULE_16_vuetify_es5_components_VGrid___default.a,
			VIcon: __WEBPACK_IMPORTED_MODULE_17_vuetify_es5_components_VIcon___default.a,
			VList: __WEBPACK_IMPORTED_MODULE_18_vuetify_es5_components_VList___default.a,
			VMenu: __WEBPACK_IMPORTED_MODULE_19_vuetify_es5_components_VMenu___default.a,
			VNavigationDrawer: __WEBPACK_IMPORTED_MODULE_20_vuetify_es5_components_VNavigationDrawer___default.a,
			VRadioGroup: __WEBPACK_IMPORTED_MODULE_21_vuetify_es5_components_VRadioGroup___default.a,
			VSelect: __WEBPACK_IMPORTED_MODULE_22_vuetify_es5_components_VSelect___default.a,
			VSlider: __WEBPACK_IMPORTED_MODULE_23_vuetify_es5_components_VSlider___default.a,
			VSnackbar: __WEBPACK_IMPORTED_MODULE_24_vuetify_es5_components_VSnackbar___default.a,
			VSubheader: __WEBPACK_IMPORTED_MODULE_25_vuetify_es5_components_VSubheader___default.a,
			VTextField: __WEBPACK_IMPORTED_MODULE_26_vuetify_es5_components_VTextField___default.a,
			VTextarea: __WEBPACK_IMPORTED_MODULE_27_vuetify_es5_components_VTextarea___default.a,
			VTimePicker: __WEBPACK_IMPORTED_MODULE_28_vuetify_es5_components_VTimePicker___default.a,
			VToolbar: __WEBPACK_IMPORTED_MODULE_29_vuetify_es5_components_VToolbar___default.a,
			VTooltip: __WEBPACK_IMPORTED_MODULE_30_vuetify_es5_components_VTooltip___default.a,
			transitions: __WEBPACK_IMPORTED_MODULE_31_vuetify_es5_components_transitions___default.a,
			VExpansionPanel: __WEBPACK_IMPORTED_MODULE_32_vuetify_es5_components_VExpansionPanel___default.a,
			VDataTable: __WEBPACK_IMPORTED_MODULE_33_vuetify_es5_components_VDataTable___default.a,
			VProgressLinear: __WEBPACK_IMPORTED_MODULE_34_vuetify_es5_components_VProgressLinear___default.a,
			VTabs: __WEBPACK_IMPORTED_MODULE_35_vuetify_es5_components_VTabs___default.a,
			VStepper: __WEBPACK_IMPORTED_MODULE_36_vuetify_es5_components_VStepper___default.a,
			VSwitch: __WEBPACK_IMPORTED_MODULE_37_vuetify_es5_components_VSwitch___default.a,
			VAutocomplete: __WEBPACK_IMPORTED_MODULE_38_vuetify_es5_components_VAutocomplete___default.a
		},
		theme: {
			primary: '#1A4338',
			secondary: '#DCEAE4',
			accent: '#12372E',
			error: '#FF5253',
			info: '#2E6B59',
			success: '#4DC68C',
			warning: '#FFB74C',
			pink: '#fe6b7d',
			base: '#1A4338'
		}
	});
});

/***/ }),
/* 226 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 240 */,
/* 241 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 253 */,
/* 254 */,
/* 255 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 256 */,
/* 257 */,
/* 258 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 259 */,
/* 260 */,
/* 261 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 270 */,
/* 271 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 272 */,
/* 273 */,
/* 274 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 275 */,
/* 276 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 277 */,
/* 278 */,
/* 279 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 280 */,
/* 281 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 282 */,
/* 283 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 291 */,
/* 292 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 293 */,
/* 294 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 302 */,
/* 303 */,
/* 304 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 310 */,
/* 311 */,
/* 312 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 313 */,
/* 314 */,
/* 315 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 316 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 317 */,
/* 318 */,
/* 319 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 320 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 321 */,
/* 322 */,
/* 323 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 324 */,
/* 325 */,
/* 326 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 327 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 328 */,
/* 329 */,
/* 330 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 331 */,
/* 332 */,
/* 333 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 340 */,
/* 341 */,
/* 342 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 343 */,
/* 344 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 345 */,
/* 346 */,
/* 347 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 348 */,
/* 349 */,
/* 350 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 351 */,
/* 352 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 357 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 358 */,
/* 359 */,
/* 360 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 366 */,
/* 367 */,
/* 368 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 373 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 380 */,
/* 381 */,
/* 382 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = httpRequestInterceptor;
/* harmony export (immutable) */ __webpack_exports__["c"] = httpResponseSuccessInterceptor;
/* harmony export (immutable) */ __webpack_exports__["b"] = httpResponseInterceptor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__errors__ = __webpack_require__(410);




function httpRequestInterceptor(config) {
	var headers = config.headers;
	if (__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.token) {
		headers.common.Authorization = 'Bearer ' + __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.token;
		__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('toggleLoading', true);
	} else {
		this.$router.push('login');
	}
	return config;
}

function httpResponseSuccessInterceptor(response) {
	__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('toggleLoading', false);
	return response;
}

function httpResponseInterceptor(error) {
	__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('toggleLoading', false);
	var text = 'Credenciales incorrectas.';
	var timeout = 5000;
	var status = error.response.status;
	var loginRoute = { name: 'login' };
	if (status === 401) {
		this.$router.push(loginRoute);
	} else if (status === 400) {
		text = Object(__WEBPACK_IMPORTED_MODULE_2__errors__["a" /* default */])(error.response);
	} else if (status === 403) {
		text = 'No tiene suficientes permisos para realizar ésta acción';
	} else if (status === 500) {
		timeout = 0;
		text = 'No se logró completar la acción, intente de nuevo.';
	}
	__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('showSnackBar', { text: text, color: 'error', timeout: timeout });
	return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.response);
}

/***/ }),
/* 399 */,
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

function clearUser(context) {
	context.commit('clearUser');
}

function toggleLoading(context, value) {
	context.commit('toggleLoading', value);
}

function showSnackBar(context, snackbar) {
	var visibleSnackBar = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, snackbar);
	visibleSnackBar.isVisible = true;
	visibleSnackBar.color = visibleSnackBar.color || 'primary';
	context.commit('showSnackBar', visibleSnackBar);
}

function setToken(context, token) {
	context.commit('setToken', token);
}

var methods = {
	clearUser: clearUser,
	setToken: setToken,
	showSnackBar: showSnackBar,
	toggleLoading: toggleLoading
};

/* harmony default export */ __webpack_exports__["a"] = (methods);

/***/ }),
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function indeterminate(state) {
	return state.appConfig.isLoading;
}

function companyLogo(state) {
	return state.user.logo;
}

function userName(state) {
	return state.user.username;
}

function token(state) {
	return state.token;
}

function snackbar(state) {
	return state.appConfig.snackbar;
}

var methods = {
	companyLogo: companyLogo,
	indeterminate: indeterminate,
	snackbar: snackbar,
	token: token,
	userName: userName
};

/* harmony default export */ __webpack_exports__["a"] = (methods);

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);


function clearUser(state) {
	__WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state, 'token', null);
}

function setToken(state, token) {
	__WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state, 'token', token);
}

function showSnackBar(state, snackbar) {
	__WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state.appConfig, 'snackbar', snackbar);
}

function toggleLoading(state, value) {
	__WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state.appConfig, 'isLoading', value);
}

var methods = {
	clearUser: clearUser,
	setToken: setToken,
	showSnackBar: showSnackBar,
	toggleLoading: toggleLoading
};

/* harmony default export */ __webpack_exports__["a"] = (methods);

/***/ }),
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);


/* harmony default export */ __webpack_exports__["a"] = (function (response) {
	var data = response && response.data !== undefined ? response.data : response;
	if (data === 'USER_EXISTS' || data && data.message === 'USER_EXISTS') {
		return 'El usuario ya existe';
	}
	if (data && typeof data.message === 'string') {
		return data.message;
	}
	if (data && (typeof data === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(data)) === 'object') {
		var firstError = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data).reduce(function (message, key) {
			if (message) return message;
			var value = data[key];
			return Array.isArray(value) ? value[0] : value;
		}, '');
		if (typeof firstError === 'string' && firstError) return firstError;
	}
	return 'Verifique que completó los datos requeridos';
});

/***/ }),
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var aclInstance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
	baseURL: 'https://ec-acl.makipos.la/api'
	// transformResponse(response) {
	// 	if (response.status >= 200 || response.status <= 299) {
	// 		return response.data.data;
	// 	}
	// 	return response;
	// },
});

var mockInstance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
	baseURL: 'https://jsonplaceholder.typicode.com'
});

var salesInstance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
	baseURL: 'https://ec-sales.makipos.la'
});

/* harmony default export */ __webpack_exports__["a"] = (function (Vue) {
	/* eslint-disable no-param-reassign */
	Vue.prototype.$http = aclInstance;
	Vue.prototype.$httpMock = mockInstance;
	Vue.prototype.$httpSales = salesInstance;
});

/***/ }),
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_router__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__login__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__todos__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__projects__ = __webpack_require__(453);





/* harmony default export */ __webpack_exports__["a"] = (function (Vue) {
	Vue.use(__WEBPACK_IMPORTED_MODULE_0_vue_router__["a" /* default */]);
	var config = new __WEBPACK_IMPORTED_MODULE_0_vue_router__["a" /* default */]({
		mode: 'history',
		routes: [{
			path: '/',
			name: 'page-home',
			redirect: '/projects',
			children: [__WEBPACK_IMPORTED_MODULE_2__todos__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__projects__["a" /* default */]],
			component: function component() {
				return __webpack_require__.e/* import() */(54).then(__webpack_require__.bind(null, 557));
			},
			meta: {
				title: 'Home'
			}
		}, __WEBPACK_IMPORTED_MODULE_1__login__["a" /* default */]]
	});
	config.beforeEach(function (to, from, next) {
		if (to.name !== 'login') {
			var token = window.localStorage.getItem("acl" + '::token');
			if (token) {
				return next();
			}
			return next({ name: 'login' });
		}
		return next();
	});
	return config;
});

/***/ }),
/* 447 */,
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	path: '/login',
	name: 'login',
	meta: {
		title: 'ACL'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(46).then(__webpack_require__.bind(null, 517));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	path: '/todos',
	name: 'page-todo',
	meta: {
		title: 'Tareas'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, 518));
	},
	children: [{
		path: 'new',
		name: 'page-todo-new',
		meta: {
			title: 'Nuevo Tarea'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(9/* duplicate */).then(__webpack_require__.bind(null, 179));
		}
	}, {
		path: ':id/edit',
		name: 'page-todo-edit',
		meta: {
			title: 'Editar Tarea'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(9/* duplicate */).then(__webpack_require__.bind(null, 179));
		},
		props: true
	}]
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 450 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 451 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-navigation-drawer',{staticClass:"pa-0",attrs:{"fixed":"","height":"auto","right":"","temporary":"","stateless":"","width":_vm.width},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},[_c('section',{staticClass:"header-modal"},[_c('header',{staticClass:"header-title"},[_c('div',{staticClass:"header-heading"},[_c('span',{staticClass:"header-icon"},[_c('v-icon',[_vm._v("tune")])],1),_vm._v(" "),_c('div',[_c('small',[_vm._v("FORMULARIO")]),_c('h2',[_vm._v(_vm._s(_vm.title))])])]),_vm._v(" "),_c('v-btn',{staticClass:"modal-close ma-0",attrs:{"flat":"","icon":"","disabled":_vm.isLoading},on:{"click":_vm.closeDrawer}},[_c('v-icon',[_vm._v("close")])],1)],1)]),_vm._v(" "),_c('section',{staticClass:"content-modal"},[_vm._t("default")],2)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apps__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__companies__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__template__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__configuration__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__globalRoles__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__web_services__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__process__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__plans__ = __webpack_require__(478);










var route = {
	path: '/projects',
	name: 'page-project',
	meta: {
		title: 'Proyectos'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 556));
	},
	children: [{
		path: 'new',
		name: 'page-project-new',
		meta: {
			title: 'Nuevo Proyecto'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(11/* duplicate */).then(__webpack_require__.bind(null, 192));
		}
	}, {
		path: ':id/edit',
		name: 'page-project-edit',
		meta: {
			title: 'Editar Proyecto'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(11/* duplicate */).then(__webpack_require__.bind(null, 192));
		},
		props: true
	}, __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__apps__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__companies__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__configuration__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__globalRoles__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__template__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__web_services__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__process__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__plans__["a" /* default */]]
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	path: ':codeProject/actions',
	name: 'page-action',
	meta: {
		title: 'Barra de Acciones'
	},
	props: true,
	component: function component() {
		return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 519));
	},
	children: [{
		path: 'new',
		name: 'page-action-new',
		meta: {
			title: 'Nueva Acción'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(3/* duplicate */).then(__webpack_require__.bind(null, 180));
		},
		props: true
	}, {
		path: ':id/edit',
		name: 'page-action-edit',
		meta: {
			title: 'Editar Acción'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(3/* duplicate */).then(__webpack_require__.bind(null, 180));
		},
		props: true
	}]
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sidebar__ = __webpack_require__(463);



var route = {
	path: ':codeProject/apps',
	name: 'page-app',
	meta: {
		title: 'Aplicaciones'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 524));
	},
	props: true,
	children: [{
		path: 'new',
		name: 'page-app-new',
		meta: {
			title: 'Nueva Aplicación'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(12/* duplicate */).then(__webpack_require__.bind(null, 183));
		},
		props: true
	}, {
		path: ':id/edit',
		name: 'page-app-edit',
		meta: {
			title: 'Editar Aplicación'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(12/* duplicate */).then(__webpack_require__.bind(null, 183));
		},
		props: true
	}, __WEBPACK_IMPORTED_MODULE_0__modules__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__sidebar__["a" /* default */]]
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__resources__ = __webpack_require__(462);


var route = {
	path: ':codeApp/modules',
	name: 'page-module',
	meta: {
		title: 'Módulos'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 522));
	},
	props: true,
	children: [{
		path: 'new',
		name: 'page-module-new',
		meta: {
			title: 'Nuevo Módulo'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(4/* duplicate */).then(__webpack_require__.bind(null, 182));
		},
		props: true
	}, {
		path: ':id/edit',
		name: 'page-module-edit',
		meta: {
			title: 'Editar Módulo'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(4/* duplicate */).then(__webpack_require__.bind(null, 182));
		},
		props: true
	}, __WEBPACK_IMPORTED_MODULE_0__resources__["a" /* default */]]
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	path: ':moduleId-:moduleName/resources',
	name: 'page-resource',
	meta: {
		title: 'Recursos'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 520));
	},
	props: true,
	children: [{
		path: ':id/edit',
		name: 'page-update-resource-edit',
		meta: {
			title: 'Editar Recurso'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(2/* duplicate */).then(__webpack_require__.bind(null, 181));
		},
		props: true
	}, {
		path: ':id/assign-actions',
		name: 'page-resource-action',
		meta: {
			title: 'Asignar Barra de Acciones'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, 521));
		},
		props: true
	}, {
		path: 'new',
		name: 'page-update-resource-new',
		meta: {
			title: 'Nuevo Recurso'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(2/* duplicate */).then(__webpack_require__.bind(null, 181));
		},
		props: true
	}]
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	path: ':codeApp/sidebar',
	name: 'page-sidebar',
	meta: {
		title: 'Sidebar'
	},
	props: true,
	component: function component() {
		return __webpack_require__.e/* import() */(53).then(__webpack_require__.bind(null, 523));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__companies_edit__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__companies_new__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__roles__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__users__ = __webpack_require__(470);





var route = {
	path: ':codeProject/companies',
	name: 'page-company',
	meta: {
		title: 'Compañías'
	},
	props: true,
	component: function component() {
		return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, 531));
	},
	children: [{
		path: ':codeCompany/company-integrations',
		name: 'page-company-integration',
		meta: {
			title: 'Integraciones'
		},
		props: true,
		component: function component() {
			return __webpack_require__.e/* import() */(50).then(__webpack_require__.bind(null, 532));
		}
	}, __WEBPACK_IMPORTED_MODULE_0__companies_edit__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__companies_new__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__roles__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__users__["a" /* default */]]
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	path: ':idCompany/:codeCompany-:nameCompany/edit',
	name: 'page-edit-company',
	meta: {
		title: 'Editar Compañía'
	},
	props: true,
	component: function component() {
		return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 184));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 466 */,
/* 467 */,
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	path: 'new',
	name: 'page-new-company',
	meta: {
		title: 'Nueva Compañía'
	},
	props: true,
	component: function component() {
		return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 184));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	path: ':codeCompany/roles',
	name: 'page-role',
	meta: {
		title: 'Roles'
	},
	props: true,
	component: function component() {
		return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 525));
	},
	children: [{
		name: 'page-role-new',
		path: 'new',
		meta: {
			title: 'Nuevo Rol'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(10/* duplicate */).then(__webpack_require__.bind(null, 185));
		},
		props: true
	}, {
		name: 'page-role-edit',
		path: ':id/edit',
		meta: {
			title: 'Editar Rol'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(10/* duplicate */).then(__webpack_require__.bind(null, 185));
		},
		props: true
	}, {
		name: 'page-access-role',
		path: ':roleId/:roleName/access',
		meta: {
			title: 'Permisos'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 526));
		},
		props: true
	}, {
		name: 'page-role-duplicate',
		path: ':id/duplicate',
		meta: {
			title: 'Duplicar Rol'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 527));
		},
		props: true
	}]
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__users_apps__ = __webpack_require__(471);


var route = {
	path: ':idCompany/users',
	name: 'page-user',
	meta: {
		title: 'Usuarios'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 529));
	},
	props: true,
	children: [{
		path: 'new',
		name: 'page-user-new',
		meta: {
			title: 'Nuevo Usuario'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(8/* duplicate */).then(__webpack_require__.bind(null, 186));
		},
		props: true
	}, {
		path: ':id/edit',
		name: 'page-user-edit',
		meta: {
			title: 'Editar Usuario'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(8/* duplicate */).then(__webpack_require__.bind(null, 186));
		},
		props: true
	}, {
		path: ':id/change',
		name: 'page-users-change-password',
		meta: {
			title: 'Cambiar Contraseña de Usuario'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 530));
		},
		props: true
	}, __WEBPACK_IMPORTED_MODULE_0__users_apps__["a" /* default */]]
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	path: ':codeUser/assign',
	name: 'page-app-user',
	meta: {
		title: 'Asignar Apps'
	},
	props: true,
	component: function component() {
		return __webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, 528));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__configuration_process__ = __webpack_require__(473);


var route = {
	path: ':codeProject/template',
	name: 'page-template',
	meta: {
		title: 'Template'
	},
	props: true,
	component: function component() {
		return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, 536));
	},
	children: [{
		name: 'page-template-detail',
		path: ':id/detail',
		meta: {
			title: 'Detalle template'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(52).then(__webpack_require__.bind(null, 537));
		},
		props: true
	}, {
		path: ':id/new',
		name: 'page-template-new',
		meta: {
			title: 'Nuevo Template'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 538));
		},
		props: true
	}, {
		path: 'clone',
		name: 'page-template-clone',
		meta: {
			title: 'Clonar Template'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 539));
		},
		props: true
	}, {
		path: ':idTemplate/resources-assignment',
		name: 'page-resources-assignment',
		meta: {
			title: 'Asignación de recursos'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 540));
		},
		props: true
	}, {
		path: ':idDistribution/distribution-resource',
		name: 'page-distribution-of-resources',
		meta: {
			title: 'Distribuidor de Recursos - Empresas'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, 541));
		},
		props: true
	}, {
		path: ':id/edit-name',
		name: 'page-template-edit',
		meta: {
			title: 'Editar Nombre'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 542));
		},
		props: true
	}, __WEBPACK_IMPORTED_MODULE_0__configuration_process__["a" /* default */]]
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	path: ':codeTemplate/configuration-process/:id',
	name: 'page-configuration-process',
	meta: {
		title: 'Configuración Procesos'
	},
	props: true,
	component: function component() {
		return __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, 533));
	},
	children: [{
		path: 'assign-integration',
		name: 'page-configuration-process-assign',
		props: true,
		meta: {
			title: 'Asignar Integración'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 534));
		}
	}, {
		path: 'assign-category',
		name: 'page-configuration-process-integration-category',
		props: true,
		meta: {
			title: 'Asignar Categoria'
		},
		component: function component() {
			return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 535));
		}
	}]
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	path: '/configuration',
	name: 'page-configuration',
	meta: {
		title: 'Configuración'
	},
	redirect: '/configuration/dealers',
	component: function component() {
		return __webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, 543));
	},
	children: [{
		name: 'page-config-dealers',
		path: 'dealers',
		meta: {
			title: 'Distribuidores',
			primary: true
		},
		component: function component() {
			return __webpack_require__.e/* import() */(13/* duplicate */).then(__webpack_require__.bind(null, 187));
		},
		props: true,
		children: [{
			name: 'page-config-projects',
			path: ':id/projects',
			meta: {
				title: 'Proyectos'
			},
			component: function component() {
				return __webpack_require__.e/* import() */(44).then(__webpack_require__.bind(null, 544));
			},
			props: true
		}, {
			name: 'page-config-template',
			path: ':id/template',
			meta: {
				title: 'Template'
			},
			component: function component() {
				return __webpack_require__.e/* import() */(43).then(__webpack_require__.bind(null, 545));
			},
			props: true
		}, {
			name: 'page-dealers-implementers',
			path: ':id/implementers',
			meta: {
				title: 'Implementadores'
			},
			component: function component() {
				return __webpack_require__.e/* import() */(45).then(__webpack_require__.bind(null, 546));
			},
			props: true
		}, {
			name: 'page-dealers-resource',
			path: ':id/resource',
			meta: {
				title: 'Recursos'
			},
			component: function component() {
				return __webpack_require__.e/* import() */(48).then(__webpack_require__.bind(null, 547));
			},
			props: true
		}, {
			name: 'page-dealers-new',
			path: ':id?/new',
			meta: {
				title: 'Crear Usuario'
			},
			component: function component() {
				return __webpack_require__.e/* import() */(6/* duplicate */).then(__webpack_require__.bind(null, 188));
			},
			props: true
		}, {
			name: 'page-dealers-application',
			path: ':id/application',
			meta: {
				title: 'Aplicaciones'
			},
			component: function component() {
				return __webpack_require__.e/* import() */(49).then(__webpack_require__.bind(null, 548));
			},
			props: true
		}]
	}, {
		name: 'page-config-implementers',
		path: 'implementers',
		meta: {
			title: 'Implementadores',
			primary: true
		},
		component: function component() {
			return __webpack_require__.e/* import() */(13/* duplicate */).then(__webpack_require__.bind(null, 187));
		},
		props: true,
		children: [{
			name: 'page-implementers-company',
			path: ':id/company',
			props: true,
			meta: {
				title: 'Empresas'
			},
			component: function component() {
				return __webpack_require__.e/* import() */(47).then(__webpack_require__.bind(null, 549));
			}
		}, {
			name: 'page-implementers-create',
			path: ':id?/new',
			meta: {
				title: 'Crear Usuario'
			},
			component: function component() {
				return __webpack_require__.e/* import() */(6/* duplicate */).then(__webpack_require__.bind(null, 188));
			},
			props: true
		}]
	}, {
		name: 'page-dealers-projects',
		path: 'dealers/:name/:id/projects',
		meta: {
			title: 'Proyectos',
			primary: true
		},
		props: true,
		component: function component() {
			return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, 550));
		},
		children: [{
			name: 'assignment-master-companies',
			path: ':codeProject/assignment-master-companies',
			component: function component() {
				return __webpack_require__.e/* import() */(42).then(__webpack_require__.bind(null, 551));
			},
			props: true
		}]
	}]
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var globalRolesRoute = {
	path: ':codeProject/roles-globales',
	name: 'roles-global',
	meta: {
		title: 'Roles Globales'
	},
	component: function component() {
		return __webpack_require__.e/* import() */(51).then(__webpack_require__.bind(null, 552));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (globalRolesRoute);

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	path: ':codeProject/web-services',
	name: 'page-web-services',
	meta: {
		title: 'Web Services'
	},
	props: true,
	component: function component() {
		return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, 553));
	},
	children: [{
		path: 'new',
		name: 'page-new-web-services',
		meta: {
			title: 'Agregar Web Services'
		},
		props: true,
		component: function component() {
			return __webpack_require__.e/* import() */(5/* duplicate */).then(__webpack_require__.bind(null, 189));
		}
	}, {
		path: ':id/edit',
		name: 'page-edit-web-services',
		meta: {
			title: 'Editar Web Services'
		},
		props: true,
		component: function component() {
			return __webpack_require__.e/* import() */(5/* duplicate */).then(__webpack_require__.bind(null, 189));
		}
	}]
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var processRoute = {
	path: ':codeProject/process',
	name: 'page-process',
	meta: {
		title: 'Procesos'
	},
	props: true,
	component: function component() {
		return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, 554));
	},
	children: [{
		path: 'new',
		name: 'create-process',
		meta: {
			title: 'Crear Procesos'
		},
		props: true,
		component: function component() {
			return __webpack_require__.e/* import() */(7/* duplicate */).then(__webpack_require__.bind(null, 190));
		}
	}, {
		path: ':id/edit',
		name: 'edit-process',
		meta: {
			title: 'Editar Procesos'
		},
		props: true,
		component: function component() {
			return __webpack_require__.e/* import() */(7/* duplicate */).then(__webpack_require__.bind(null, 190));
		}
	}]
};

/* harmony default export */ __webpack_exports__["a"] = (processRoute);

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__plans_new__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__plans_edit__ = __webpack_require__(480);



var route = {
	path: ':codeProject/plans',
	name: 'page-plan',
	meta: {
		title: 'Planes'
	},
	props: true,
	component: function component() {
		return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 555));
	},
	children: [__WEBPACK_IMPORTED_MODULE_0__plans_new__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__plans_edit__["a" /* default */]]
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	path: 'new',
	name: 'page-new-plan',
	meta: {
		title: 'Nuevo Plan'
	},
	props: true,
	component: function component() {
		return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 191));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var route = {
	path: ':idPlan/:codePlan-:namePlan/edit',
	name: 'page-edit-plan',
	meta: {
		title: 'Editar Plan'
	},
	props: true,
	component: function component() {
		return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 191));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (route);

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);






var loadData = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(url) {
		var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

		var query, _ref2, records, headers, rows, totalRecords;

		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						query = {
							params: this.params
						};

						if (version === 2) {
							query.headers = {
								Accept: '' + 'application/vnd.apiacl.v2+json'
							};
						}
						_context.next = 4;
						return this.$http.get(url, query);

					case 4:
						_ref2 = _context.sent;
						records = _ref2.data;
						headers = _ref2.headers;

						this.table.lastPage = Number(headers['x-last-page']);
						rows = records.data.map(function (row) {
							var newRow = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, row);
							newRow.isSelected = !!row.isSelected || !!row.flagSelected;
							return newRow;
						});
						totalRecords = Number(headers['x-quantity']);

						rows.totalRecords = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan___default()(totalRecords) ? rows.length : totalRecords;
						this.table.rows = rows;
						return _context.abrupt('return', { records: records, headers: headers });

					case 13:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function loadData(_x) {
		return _ref.apply(this, arguments);
	};
}();

function data() {
	return {
		modalConfirmation: {
			selectedRow: {},
			value: false
		},
		languages: {
			es: {
				id: 'Es',
				name: 'Español',
				isSelected: false
			},
			en: {
				id: 'En',
				name: 'English',
				isSelected: false
			}
		},
		params: {
			page: 1,
			perPage: 20,
			search: null
		},
		table: {
			lastPage: 0,
			rows: []
		}
	};
}

function cancelModalConfirmation() {
	this.modalConfirmation.value = false;
}

function goTo(name, options) {
	var navigationOptions = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, options || {});
	var returnTo = this.$route.query.returnTo;
	if (!navigationOptions.query && returnTo) {
		navigationOptions.query = {
			returnTo: returnTo,
			returnParams: this.$route.query.returnParams
		};
	}
	this.$router.push(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({ name: name }, navigationOptions));
}

function getImageUrl(imageUrl) {
	return this.$imageUrl + '/' + imageUrl;
}

function onSearch(value, url) {
	this.params.page = 1;
	if (typeof this.currentPage !== 'undefined') {
		this.currentPage = 1;
	}
	this.params.search = value || null;
	this.loadData(url);
}

function openModalConfirmation(row) {
	this.modalConfirmation.selectedRow = row;
	this.modalConfirmation.value = true;
}

function showError() {
	var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Oops, ocurrió un error.';

	this.$store.dispatch('showSnackBar', { text: text, color: 'error' });
}

function showNotification(text) {
	var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'success';

	this.$store.dispatch('showSnackBar', { text: text, color: color });
}

function showParentView(name) {
	return this.$route.name.indexOf(name) > -1;
}

function showRow(columns, columnId) {
	var column = columns.find(function (h) {
		return h.id === columnId;
	});
	return column.visible;
}

function selectIsRow(array) {
	var flag = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'isSelected';
	var row = arguments[2];
	var checked = arguments[3];
	var config = arguments[4];

	var arrayNew = array.map(function (rowData) {
		var newRowData = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, rowData);
		if (config) {
			if (newRowData[config]) {
				newRowData[flag] = checked;
			} else {
				newRowData[flag] = false;
			}
		} else if (row) {
			if (rowData.id === row.id) {
				newRowData[flag] = row[flag];
			}
		} else {
			newRowData[flag] = checked;
		}
		return newRowData;
	});
	return arrayNew;
}

function every(array) {
	var flag = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'isSelected';
	var disabled = arguments[2];

	var newArray = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], array);
	var returnEvery = void 0;
	if (disabled) {
		returnEvery = newArray.every(function (element) {
			return !element[flag];
		});
	} else {
		returnEvery = newArray.every(function (element) {
			return element[flag];
		});
	}
	return returnEvery;
}

function token() {
	return this.$store.getters.token;
}

var mixin = {
	data: data,
	computed: {
		token: token
	},
	methods: {
		cancelModalConfirmation: cancelModalConfirmation,
		getImageUrl: getImageUrl,
		goTo: goTo,
		loadData: loadData,
		onSearch: onSearch,
		openModalConfirmation: openModalConfirmation,
		showError: showError,
		showNotification: showNotification,
		showParentView: showParentView,
		showRow: showRow,
		selectIsRow: selectIsRow,
		every: every
	}
};

/* harmony default export */ __webpack_exports__["a"] = (mixin);

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_format__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_date_fns_format__);


function round(value) {
	var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

	var newValue = Number(value);
	return newValue.toFixed(decimals);
}

function limitTo(value) {
	var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;

	var cutText = value.substring(0, length);
	return cutText + '...';
}

function formatDate(date) {
	var formatter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD';

	var newDate = __WEBPACK_IMPORTED_MODULE_0_date_fns_format___default()(new Date(date), formatter);
	return newDate;
}

/* harmony default export */ __webpack_exports__["a"] = (function (Vue) {
	Vue.filter('round', round);
	Vue.filter('limitTo', limitTo);
	Vue.filter('formatDate', formatDate);
});

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layouts_layout_login__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layouts_layout_admin__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_general_filter__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_table_app_table__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shared_header_page__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_form_section__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_shared_form_sidebar__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_shared_utils_modal_sidebar_button__ = __webpack_require__(512);











__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('layout-login', __WEBPACK_IMPORTED_MODULE_1__layouts_layout_login__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('layout-admin', __WEBPACK_IMPORTED_MODULE_2__layouts_layout_admin__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('app-table', __WEBPACK_IMPORTED_MODULE_4__components_shared_table_app_table__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('header-page', __WEBPACK_IMPORTED_MODULE_5__components_shared_header_page__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('general-filter', __WEBPACK_IMPORTED_MODULE_3__components_shared_general_filter__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('form-section', __WEBPACK_IMPORTED_MODULE_6__components_shared_form_section__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('form-sidebar', __WEBPACK_IMPORTED_MODULE_7__components_shared_form_sidebar__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('modal-sidebar-button', __WEBPACK_IMPORTED_MODULE_8__components_shared_utils_modal_sidebar_button__["a" /* default */]);

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_login_vue__ = __webpack_require__(154);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2496fe80_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_login_vue__ = __webpack_require__(486);
function injectStyle (ssrContext) {
  __webpack_require__(485)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2496fe80"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2496fe80_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 485 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_admin_vue__ = __webpack_require__(155);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_116c76e7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_admin_vue__ = __webpack_require__(492);
function injectStyle (ssrContext) {
  __webpack_require__(488)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-116c76e7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_admin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_116c76e7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_admin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 488 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_header_vue__ = __webpack_require__(156);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03532a9c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_header_vue__ = __webpack_require__(491);
function injectStyle (ssrContext) {
  __webpack_require__(490)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-03532a9c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03532a9c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 490 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{staticClass:"app-header",attrs:{"app":"","height":"56","color":"white"}},[_c('v-container',{staticClass:"app-header-container",attrs:{"fluid":"","py-0":""}},[_c('v-layout',{attrs:{"row":"","justify-space-between":"","align-center":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('router-link',{staticClass:"brand-link",attrs:{"to":"/"}},[_c('span',{staticClass:"brand-icon"},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("security")])],1),_vm._v(" "),_c('span',{staticClass:"brand-copy"},[_c('strong',[_vm._v("ACL")]),_vm._v(" "),_c('small',[_vm._v("QUIPUSOFT SA")])])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","text-xs-right":""}},[_c('div',{staticClass:"flex-item justify-end align-center"},[_c('v-btn',{staticClass:"notification-btn",attrs:{"flat":"","icon":"","color":"primary"},on:{"click":_vm.openNotifications}},[_c('span',{staticClass:"notification-quantity"},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.quantityNotifications)+"\n\t\t\t\t\t\t")]),_vm._v(" "),_c('v-icon',[_vm._v("notifications_none")])],1),_vm._v(" "),_c('v-menu',{attrs:{"offset-y":"","left":"","content-class":"profile-menu","min-width":"230"}},[_c('button',{staticClass:"profile-button",attrs:{"slot":"activator","type":"button"},slot:"activator"},[_c('span',{staticClass:"profile-image-container"},[_c('v-icon',[_vm._v("person")])],1),_vm._v(" "),_c('span',{staticClass:"profile-copy"},[_c('strong',[_vm._v(_vm._s(_vm.userName || 'Usuario'))]),_vm._v(" "),_c('small',[_vm._v("Mi cuenta")])]),_vm._v(" "),_c('v-icon',{attrs:{"size":"18"}},[_vm._v("keyboard_arrow_down")])],1),_vm._v(" "),_c('v-card',{staticClass:"profile-menu-card"},[_c('v-card-title',{staticClass:"profile-menu-header"},[_c('span',{staticClass:"profile-menu-avatar"},[_c('v-icon',[_vm._v("person")])],1),_vm._v(" "),_c('div',[_c('strong',[_vm._v(_vm._s(_vm.userName || 'Usuario'))]),_vm._v(" "),_c('small',[_vm._v("Sesión activa")])])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-btn',{staticClass:"logout-button ma-0",attrs:{"flat":"","block":""},on:{"click":_vm.logout}},[_c('v-icon',{staticClass:"mr-2",attrs:{"size":"19"}},[_vm._v("exit_to_app")]),_vm._v("\n\t\t\t\t\t\t\t\tCerrar sesión\n\t\t\t\t\t\t\t")],1)],1)],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('transition',{attrs:{"name":"loading-fade"}},[(_vm.showIndeterminate)?_c('div',{staticClass:"global-loading",attrs:{"role":"status","aria-live":"polite"}},[_c('div',{staticClass:"global-loading-card"},[_c('div',{staticClass:"global-spinner",attrs:{"aria-hidden":"true"}},[_c('span'),_vm._v(" "),_c('v-icon',{attrs:{"color":"white"}},[_vm._v("security")])],1),_vm._v(" "),_c('div',{staticClass:"global-loading-copy"},[_c('strong',[_vm._v("Cargando información")]),_vm._v(" "),_c('span',[_vm._v("Estamos preparando los datos...")])])])]):_vm._e()]),_vm._v(" "),_c('app-header',{attrs:{"quantity-notifications":_vm.quantityNotifications},on:{"open-notifications-event":_vm.openNotificationsModal}}),_vm._v(" "),_c('v-container',{staticClass:"admin-shell",attrs:{"fluid":"","pa-0":""}},[_vm._t("default"),_vm._v(" "),_c('footer',{staticClass:"admin-copyright"},[_c('span',[_vm._v("© "+_vm._s(_vm.currentYear)+" QUIPUSOFT S.A.")]),_vm._v(" "),_c('span',{staticClass:"copyright-separator",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',[_vm._v("Todos los derechos reservados")])]),_vm._v(" "),_c('action-sidebar',{attrs:{"width":_vm.action.width,"code-action":_vm.action.code,"title":_vm.action.title,"active":_vm.action.active,"img-src":_vm.action.imgSrc,"is-loading":_vm.loading,"header-color":_vm.action.color},model:{value:(_vm.action.open),callback:function ($$v) {_vm.$set(_vm.action, "open", $$v)},expression:"action.open"}})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_general_filter_vue__ = __webpack_require__(157);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e69269a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_general_filter_vue__ = __webpack_require__(495);
function injectStyle (ssrContext) {
  __webpack_require__(494)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5e69269a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_general_filter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e69269a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_general_filter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 494 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"general-filter"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_table_vue__ = __webpack_require__(158);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a17a3be_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_table_vue__ = __webpack_require__(501);
function injectStyle (ssrContext) {
  __webpack_require__(497)
  __webpack_require__(498)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6a17a3be"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_table_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a17a3be_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 497 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 498 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_table_column_item_vue__ = __webpack_require__(159);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0010e990_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_table_column_item_vue__ = __webpack_require__(500);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_table_column_item_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0010e990_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_table_column_item_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{attrs:{"id":'column-' + _vm.column.id}},[_vm._v("\n\t"+_vm._s(_vm.column.name)+"\n\t"),(_vm.column.isSortable)?_c('button',{staticClass:"sortable-button",on:{"click":function($event){return _vm.onColumnSortable(_vm.column)}}},[(_vm.column.isSortable.down)?_c('i',{staticClass:"sortable-icon material-icons icon"},[_vm._v("arrow_drop_down")]):_vm._e(),_vm._v(" "),(_vm.column.isSortable.up)?_c('i',{staticClass:"sortable-icon material-icons icon"},[_vm._v("arrow_drop_up")]):_vm._e()]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-table-wrapper",class:{ 'app-table-contained': _vm.contained }},[_c('table',{staticClass:"table-list",class:[
		_vm.appearanceClass,
		{
			'table-compact': _vm.compact,
			'table-contained': _vm.contained,
			'table-selectable': _vm.selectable,
			'table-sticky-header': _vm.stickyHeader,
		} ],attrs:{"border":"0","cellpadding":"0","cellspacing":"0"}},[(_vm.hasColumnWidths)?_c('colgroup',[(_vm.selectable)?_c('col',{staticStyle:{"width":"44px"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.columns),function(column){return (column.visible)?_c('col',{key:("column-width-" + (column.id)),style:({ width: _vm.columnWidths[column.id] || 'auto' })}):_vm._e()})],2):_vm._e(),_vm._v(" "),_c('thead',{staticClass:"primary"},[(_vm.inputSearch || _vm.filterColumns || _vm.includeFilter || _vm.addButton)?_c('tr',[_c('th',{attrs:{"colspan":_vm.totalVisibleColumns}},[_c('div',{staticClass:"table-tools-row"},[_c('div',{staticClass:"table-tools-title"},[_c('span',[_c('v-icon',[_vm._v("view_list")])],1),_vm._v(" "),_c('div',[_c('strong',[_vm._v("Registros")]),_c('small',[_vm._v(_vm._s(_vm.formattedRecordTotal)+" disponibles")])])]),_vm._v(" "),_c('div',{staticClass:"table-tools-actions",class:("text-xs-" + _vm.direction)},[(_vm.inputSearch)?_c('div',{staticClass:"search-input align-center"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],attrs:{"type":"text"},domProps:{"value":(_vm.search)},on:{"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.searchRows.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.searchRows.apply(null, arguments)}],"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}}),_vm._v(" "),_c('v-icon',{staticClass:"search-icon",attrs:{"size":"20"}},[_vm._v("\n\t\t\t\t\t\tsearch\n\t\t\t\t\t")])],1):_vm._e(),_vm._v(" "),(_vm.filterColumns)?_c('v-menu',{attrs:{"offset-y":"","max-height":"300","content-class":"columns-menu","fixed":"","close-on-content-click":false},model:{value:(_vm.showMenu),callback:function ($$v) {_vm.showMenu=$$v},expression:"showMenu"}},[_c('button',{attrs:{"slot":"activator","type":"button"},slot:"activator"},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("view_column")])],1),_vm._v(" "),_c('div',{staticClass:"content-checkbox"},[_vm._l((_vm.columns),function(column){return (!column.flagVisible)?_c('v-checkbox',{key:column.id,staticClass:"filter-columns",staticStyle:{"background":"white","width":"300px","line-height":"normal"},attrs:{"label":column.name,"hide-details":"","color":"success"},model:{value:(column.checked),callback:function ($$v) {_vm.$set(column, "checked", $$v)},expression:"column.checked"}}):_vm._e()}),_vm._v(" "),_c('div',{staticClass:"apply text-xs-center"},[_c('v-btn',{staticClass:"btn-action mb-2 mt-2",attrs:{"color":"primary"},on:{"click":_vm.toggleColumns}},[_vm._v("Aplicar")])],1)],2)]):_vm._e(),_vm._v(" "),(_vm.includeFilter)?_c('button',{attrs:{"type":"button"},on:{"click":_vm.tableOption}},[_c('v-icon',[_vm._v("filter_list")])],1):_vm._e(),_vm._v(" "),(_vm.addButton)?_c('button',{attrs:{"type":"button"},on:{"click":_vm.addOption}},[_c('v-icon',[_vm._v("add")])],1):_vm._e()],1)])])]):_vm._e(),_vm._v(" "),_c('tr',[(_vm.selectable)?_c('th',[_c('input',{staticClass:"input-checkbox",attrs:{"type":"checkbox","disabled":_vm.disabledTable},domProps:{"value":_vm.checkAll,"checked":_vm.checkAll},on:{"change":function($event){return _vm.selectedAll($event)}}})]):_vm._e(),_vm._v(" "),_vm._l((_vm.columns),function(column){return _c("table-column-item",{directives:[{name:"show",rawName:"v-show",value:(column.visible),expression:"column.visible"}],key:column.id,tag:"th",staticClass:"text-xs-center",attrs:{"column":column}})})],2)]),_vm._v(" "),_c('tbody',[_vm._l((_vm.rows),function(row){return _c('tr',{key:row[_vm.keyValue],class:{ 'row-checked' : row[_vm.selectedValue] }},[(_vm.selectable)?_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row[_vm.selectedValue]),expression:"row[selectedValue]"}],staticClass:"input-checkbox",attrs:{"type":"checkbox","disabled":row.disabled},domProps:{"checked":Array.isArray(row[_vm.selectedValue])?_vm._i(row[_vm.selectedValue],null)>-1:(row[_vm.selectedValue])},on:{"click":function($event){return _vm.rowIsSelected(row)},"change":function($event){var $$a=row[_vm.selectedValue],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(row, _vm.selectedValue, $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(row, _vm.selectedValue, $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(row, _vm.selectedValue, $$c)}}}})]):_vm._e(),_vm._v(" "),_vm._t("rows",null,{"row":row})],2)})],2),_vm._v(" "),_c('tfoot',{staticClass:"table-pagination"},[(_vm.mainList && _vm.rows.length > 0)?_c('tr',[_c('td',{attrs:{"colspan":_vm.totalVisibleColumns}},[_c('div',{staticClass:"pagination-footer"},[_c('div',{staticClass:"pagination-summary"},[_c('span',{staticClass:"records-badge"},[_vm._v(_vm._s(_vm.formattedRecordTotal))]),_vm._v(" "),_c('span',[_vm._v("registros totales · Mostrando "),_c('strong',[_vm._v(_vm._s(_vm.rows.length))]),_vm._v(" en esta página")]),_vm._v(" "),_c('span',{staticClass:"pagination-divider"}),_vm._v(" "),_c('span',[_vm._v("Página "),_c('strong',[_vm._v(_vm._s(_vm.currentPage))]),_vm._v(" de "),_c('strong',[_vm._v(_vm._s(_vm.lastPage))])])]),_vm._v(" "),_c('nav',{staticClass:"pagination-controls",attrs:{"aria-label":"Paginación de la tabla"}},[_c('button',{attrs:{"type":"button","title":"Primera página","disabled":_vm.currentPage <= 1},on:{"click":function($event){return _vm.selectPage(1)}}},[_c('v-icon',[_vm._v("first_page")])],1),_vm._v(" "),_c('button',{attrs:{"type":"button","title":"Página anterior","disabled":_vm.currentPage <= 1},on:{"click":function($event){return _vm.selectPage(_vm.currentPage - 1)}}},[_c('v-icon',[_vm._v("chevron_left")])],1),_vm._v(" "),_vm._l((_vm.pages),function(page,index){return _c('button',{key:index,staticClass:"page-number",class:{ 'active-page': page === _vm.currentPage, 'page-dots': page === '...' },attrs:{"disabled":page === '...'},on:{"click":function($event){return _vm.selectPage(page)}}},[_vm._v(_vm._s(page))])}),_vm._v(" "),_c('button',{attrs:{"type":"button","title":"Página siguiente","disabled":_vm.currentPage >= _vm.lastPage},on:{"click":function($event){return _vm.selectPage(_vm.currentPage + 1)}}},[_c('v-icon',[_vm._v("chevron_right")])],1),_vm._v(" "),_c('button',{attrs:{"type":"button","title":"Última página","disabled":_vm.currentPage >= _vm.lastPage},on:{"click":_vm.selectLastPage}},[_c('v-icon',[_vm._v("last_page")])],1)],2)])])]):_vm._e(),_vm._v(" "),(_vm.rows.length === 0)?_c('tr',[_c('td',{attrs:{"colspan":_vm.totalVisibleColumns}},[_c('p',{staticStyle:{"text-align":"center","margin":"5px 0 0 5px"}},[_vm._v("\n\t\t\t\t\tNo hay información que mostrar\n\t\t\t\t")])])]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_page_vue__ = __webpack_require__(160);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d3a0925_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_page_vue__ = __webpack_require__(504);
function injectStyle (ssrContext) {
  __webpack_require__(503)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3d3a0925"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_page_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d3a0925_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_page_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 503 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-header-page"},[_c('nav',{staticClass:"modern-breadcrumb",attrs:{"aria-label":"Navegación"}},[_c('button',{staticClass:"configuration-link",attrs:{"type":"button","title":"Abrir configuración"},on:{"click":_vm.openConfiguration}},[_c('v-icon',[_vm._v("settings")]),_vm._v(" "),_c('span',[_vm._v("Configuración")])],1),_vm._v(" "),_c('span',{staticClass:"configuration-separator"}),_vm._v(" "),(_vm.breadcrumbs.length > 2)?_c('button',{staticClass:"back-link",attrs:{"type":"button"},on:{"click":_vm.goBack}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("arrow_back")]),_vm._v(" "),_c('span',[_vm._v("Volver")])],1):_vm._e(),_vm._v(" "),(_vm.breadcrumbs.length > 2)?_c('span',{staticClass:"back-separator"}):_vm._e(),_vm._v(" "),_c('button',{staticClass:"home-link",attrs:{"type":"button","title":"Ir a proyectos"},on:{"click":_vm.openHome}},[_c('v-icon',[_vm._v("home")]),_vm._v(" "),_c('span',[_vm._v("Inicio")])],1),_vm._v(" "),_vm._l((_vm.visibleBreadcrumbs),function(item,index){return [(index > 0)?[_c('v-icon',{key:("divider-" + (item.title) + "-" + index),staticClass:"breadcrumb-divider"},[_vm._v("chevron_right")]),_vm._v(" "),(index === _vm.visibleBreadcrumbs.length - 1)?_c('span',{key:("current-" + (item.title) + "-" + index),staticClass:"breadcrumb-current",attrs:{"aria-current":"page"}},[_vm._v(_vm._s(item.title))]):(!item.name)?_c('span',{key:("context-" + (item.title) + "-" + index),staticClass:"breadcrumb-context"},[_vm._v(_vm._s(item.title))]):_c('button',{key:("link-" + (item.title) + "-" + index),staticClass:"breadcrumb-link",attrs:{"type":"button"},on:{"click":function($event){return _vm.openLink(item)}}},[_vm._v(_vm._s(item.title))])]:_vm._e()]})],2),_vm._v(" "),(_vm.toShow)?_c('div',{staticClass:"header-page-actions"},[(_vm.exportToPdf)?_c('v-btn',{staticClass:"header-page-download-document primary mr-2",on:{"click":function($event){$event.preventDefault();return _vm.downloadDispatch.apply(null, arguments)}}},[_c('v-icon',{attrs:{"size":"19"}},[_vm._v("picture_as_pdf")])],1):_vm._e(),_vm._v(" "),(_vm.showExcel)?_c('v-btn',{staticClass:"header-page-download-document primary",on:{"click":_vm.downloadDocument}},[_c('v-icon',{attrs:{"size":"19"}},[_vm._v("grid_on")])],1):_vm._e(),_vm._v(" "),(_vm.showClean)?_c('v-btn',{on:{"click":_vm.cleanFilter}},[_vm._v("Limpiar")]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.quotation || _vm.sale)?_c('div',{staticClass:"header-page-actions translate"},[_c('v-btn',{staticClass:"header-page-download-document",attrs:{"flat":""},on:{"click":_vm.downloadDocument}},[_c('v-icon',{attrs:{"size":"19"}},[_vm._v("file_download")])],1),_vm._v(" "),_c('v-btn',{staticClass:"header-page-download-document",attrs:{"flat":""},on:{"click":_vm.print}},[_c('v-icon',{attrs:{"size":"19"}},[_vm._v("print")])],1)],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_section_vue__ = __webpack_require__(161);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_be65f078_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_form_section_vue__ = __webpack_require__(507);
function injectStyle (ssrContext) {
  __webpack_require__(506)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_section_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_be65f078_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_form_section_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 506 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"form-section",class:[("form-section--" + _vm.tone), { 'form-section--tight': _vm.tight }]},[_c('header',{staticClass:"form-section__head"},[_c('span',{staticClass:"form-section__icon"},[_c('v-icon',[_vm._v(_vm._s(_vm.icon))])],1),_vm._v(" "),_c('div',{staticClass:"form-section__heading"},[(_vm.eyebrow)?_c('small',[_vm._v(_vm._s(_vm.eyebrow))]):_vm._e(),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.description)?_c('p',[_vm._v(_vm._s(_vm.description))]):_vm._e()]),_vm._v(" "),(_vm.badge)?_c('span',{staticClass:"form-section__badge"},[_vm._v(_vm._s(_vm.badge))]):_vm._e(),_vm._v(" "),_vm._t("aside")],2),_vm._v(" "),_c('div',{staticClass:"form-section__body"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_sidebar_vue__ = __webpack_require__(162);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d86cd7dc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_form_sidebar_vue__ = __webpack_require__(511);
function injectStyle (ssrContext) {
  __webpack_require__(509)
  __webpack_require__(510)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d86cd7dc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d86cd7dc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_form_sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 509 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 510 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-sidebar"},[_c('v-container',{staticClass:"form-sidebar-container grid-list-lg"},[_vm._t("default")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modal_sidebar_button_vue__ = __webpack_require__(163);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5954bcf6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modal_sidebar_button_vue__ = __webpack_require__(514);
function injectStyle (ssrContext) {
  __webpack_require__(513)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5954bcf6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modal_sidebar_button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5954bcf6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modal_sidebar_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 513 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"footer-modal"},[_c('div',{staticClass:"footer-container"},[(_vm.helperText)?_c('small',{staticClass:"footer-helper"},[_c('v-icon',[_vm._v("info_outline")]),_vm._v(_vm._s(_vm.helperText)+"\n\t\t")],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"footer-buttons"},[(!_vm.hidden)?_c('v-btn',{staticClass:"btn-action cancel-action caption",attrs:{"color":"pink","disabled":_vm.onRunService},on:{"click":_vm.cancelModal}},[_vm._v("\n\t\t\t\tCancelar\n\t\t\t\t"),_c('v-icon',{staticClass:"ml-2",attrs:{"size":"18"}},[_vm._v("close")])],1):_vm._e(),_vm._v(" "),(!_vm.hiddenSaveBtn)?_c('v-btn',{staticClass:"btn-action save-action caption",attrs:{"color":_vm.successColor,"disabled":_vm.isLoading},on:{"click":_vm.setInfo}},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.successText)+"\n\t\t\t\t"),_c('v-icon',{staticClass:"ml-2",attrs:{"size":"18"}},[_vm._v("check")])],1):_vm._e(),_vm._v(" "),_vm._t("default")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
]),[193]);


// WEBPACK FOOTER //
// static/js/app.3611a105efcea77e7a79.js